import axios from 'axios'
import _ from 'lodash'
import HOTELS from '@/api/hotels'
import dayjs from 'dayjs'

// initial state
const state = {
  externalHotelSource: ['yokoso', 'hotelbeds'],
  // Map
  isLoadingHotelsMap: true,
  hotelsMap: [],
  hotelsMapCancelToken: false,
  // Hotels
  isLoadingHotel: true,
  isLoadingHotels: false,
  isLoadingFavorite: false,
  isQuarantineHotel: false,
  hotelsCancelToken: false,
  hotels: {
    data: {},
    pagination: {}
  },
  hotel: {},
  hotelAddons: [],
  hotelsDetail: [],
  hotelId: null,
  isLoadingRooms: true,
  roomCancelToken: false,
  rooms: [],
  setRoomsFailed: false,
  featuresFilter: [
    'on_yokoso_14'
  ],
  featuresHighLight: [
    'common_wifi',
    'portable_wifi_sharer',
    'on_yokoso_5',
    'parking',
    'indoor_swimming_pool',
    'outdoor_swimming_pool',
    'restaurant',
    'on_yokoso_17',
    'gym',
    'on_yokoso_19',
    'airport_transfer',
    'on_yokoso_12',
    'business_center',
    'tesla_charger',
    // YOKOSO
    'on_yokoso_1',
    'on_yokoso_3',
    'on_yokoso_4',
    'on_yokoso_7',
    'on_yokoso_9',
    'on_yokoso_10',
    'on_yokoso_15',
    'on_yokoso_21',
    'on_yokoso_22',
    'on_yokoso_23',
    'on_yokoso_24',
    'on_yokoso_28',
    'on_yokoso_31',
    'on_yokoso_32',
    'on_yokoso_33'
  ],
  quarantineDatepickerStyle: [],
  allowances: [],
  inventory: null,
  inventoryPrice: null,
  isLoadingInventory: false,
  hotelNearby: [],
  isLoadingHotelNearby: false,
  scrolling: false,
  pageYOffset: 0
}

// getters
const getters = {
  externalHotelSource: () => {
    return state.externalHotelSource
  },
  isLoadingHotelsMap: (state) => {
    return state.isLoadingHotelsMap
  },
  mapList: (state) => {
    return state.hotelsMapList
  },
  map: (state) => {
    return state.hotelsMap
  },
  isLoadingHotel: (state, getters) => {
    const isHotel = getters.hotelDetail(state.hotelId)[0]
    if (isHotel) {
      return false
    }
    return state.isLoadingHotel
  },
  isLoadingHotels: (state) => {
    return state.isLoadingHotels
  },
  isLoadingFavorite: (state) => {
    return state.isLoadingFavorite
  },
  isQuarantineHotel: (state) => {
    return state.isQuarantineHotel
  },
  hotels: (state) => {
    return state.hotels
  },
  hotel: (state, getters) => {
    const isHotel = getters.hotelDetail(getters.hotelId)[0]
    if (isHotel) {
      return isHotel
    }
    return state.hotel
  },
  hotelDetail: (state) => {
    return hotelId => state.hotelsDetail.filter(item => {
      return item.hotelUUID === hotelId
    })
  },
  hotelAddons: (state) => {
    return state.hotelAddons
  },
  hotelId: (state) => {
    return state.hotelId
  },
  isLoadingRooms: (state) => {
    return state.isLoadingRooms
  },
  setRoomsFailed: (state) => {
    return state.setRoomsFailed
  },
  rooms: (state) => {
    return _.orderBy(state.rooms?.filter(e => e.lowestStock > 0), ['lowestPrice', 'lowestStock', 'id'], ['asc', 'desc', 'asc'])
      .concat(_.orderBy(state.rooms?.filter(e => e.lowestStock === 0), ['lowestPrice', 'lowestStock', 'id'], ['asc', 'desc', 'asc']))
  },
  isCurrencyConvert: (state, getters, rootState, rootGetters) => {
    return (state.hotel.currency ? state.hotel.currency : rootGetters['order/currency']) !== rootGetters['user/selectedCurrency']
  },
  featuresFilter: (state) => {
    return state.featuresFilter
  },
  featuresHighLight: (state) => {
    return state.featuresHighLight
  },
  quarantineDatepickerStyle: (state) => {
    return state.quarantineDatepickerStyle
  },
  inventory: (state) => {
    return state.inventory
  },
  inventoryPrice: (state) => {
    return state.inventoryPrice
  },
  isLoadingInventory: (state) => {
    return state.isLoadingInventory
  },
  hotelNearby: (state) => {
    return state.hotelNearby
  },
  isScrolling: (state) => {
    return state.scrolling
  },
  pageYOffset: (state) => {
    return state.pageYOffset
  }
}

// actions
const actions = {
  fetchAllowances: function ({ commit }) {
    return HOTELS.getAllowances().then(res => {
      commit('SET_ALLOWANCES', res.data)
    })
  },
  fetchHotelsMapByLocation: function ({ commit }, query) {
    if (state.hotelsMapCancelToken) {
      state.hotelsMapCancelToken.cancel('Cancel hotelsMapByLocation fetching.')
    }
    commit('SET_LOADING_HOTELS_MAP', true)
    // commit('SET_HOTELS_MAP_CANCEL_TOKEN')
    return HOTELS.getHotelsMapByLocation(query, state.hotelsMapCancelToken).then(res => {
      commit('SET_HOTELS_MAP', res.data && res.data.hotels)
      commit('SET_LOADING_HOTELS_MAP', false)
      return res
    }, err => {
      console.error('fetchHotelRooms', err)
    })
  },
  fetchDefaultSearchList: function ({ commit, state, rootGetters }, params) {
    return HOTELS.getDefaultSeachList(params).then(res => {
      return res.data
    }).catch(err => {
      return Promise.reject(err)
    })
  },
  fetchHotels: function ({ commit, state }, query) {
    if (state.hotelsCancelToken) {
      state.hotelsCancelToken.cancel('Cancel hotels fetching.')
    }
    commit('SET_LOADING_HOTELS', true)
    const params = {
      ...query,
      startDate: query.start,
      endDate: query.end,
      owlmapId: query.searchId
    }
    if (params.start) {
      delete params.start
    }
    if (params.end) {
      delete params.end
    }
    return HOTELS.getHotelsV3(params, state.hotelsCancelToken).then(res => {
      const quarantineFilterId = 8
      // 移除防疫旅館 filterId
      res.data.hotelTypeData = res.data.hotelTypeData.filter(data => data.filterId !== quarantineFilterId)
      commit('SET_HOTELS_LIST', res)
      commit('SET_LOADING_HOTELS', false)
      commit('SET_LOADING_FAVORITE', false)
      return res
    }).catch(err => {
      const isCanceled = err.__CANCEL__
      if (isCanceled) return
      console.error('fetchHotels', err)
      // Clear hotels list
      commit('SET_HOTELS_LIST', {
        data: [],
        pagination: {}
      })
      commit('SET_LOADING_HOTELS', false)
      commit('SET_LOADING_FAVORITE', false)
      return Promise.reject(err)
    })
  },
  fetchDetail: function ({ commit, state }, hotelId) {
    commit('SET_LOADING_HOTEL', true)
    commit('SET_HOTEL_ID', hotelId)
    return HOTELS.getHotel(hotelId).then(res => {
      if (res.data) {
        commit('SET_LOADING_HOTEL', false)
        commit('SET_HOTEL', res.data)
        commit('SET_HOTEL_ADDONS', res.data?.extraAddons)
        commit('SET_HOTELS_DETAIL', res.data)
      }
      return res
    })
  },
  fetchHotelInventory: function ({ commit, state }, params) {
    commit('SET_ISLOADINGINVENTORY', true)
    return HOTELS.getHotelInventoryV3(params)
      .then(res => {
        if (res && res.status === 200) {
          commit('SET_INVENTORY', res.data)
          return res.data
        } else {
          return null
        }
      })
      .finally(() => {
        commit('SET_ISLOADINGINVENTORY', false)
      })
  },
  fetchHotelInventoryPrice: function ({ commit, state }, params) {
    commit('SET_ISLOADINGINVENTORY', true)
    return HOTELS.getHotelInventoryLowestPriceV3(params)
      .then(res => {
        if (res && res.status === 200) {
          commit('SET_INVENTORY_PRICE', res.data)
          return res.data
        } else {
          return null
        }
      })
      .finally(() => {
        commit('SET_ISLOADINGINVENTORY', false)
      })
  },
  fetchHotelTripAdvisorReview: function ({ commit, state }, hotelId) {
    return HOTELS.getHotelTripAdvisorReview(hotelId).then(res => {
      if (res && res.status === 200) {
        return res.data
      } else {
        return null
      }
    })
  },
  fetchHotelRooms: function ({ commit, state, rootState }, hotelId) {
    if (state.roomCancelToken) {
      state.roomCancelToken.cancel('Cancel rooms fetching.')
    }
    commit('SET_HOTEL_ID', hotelId)
    commit('SET_LOADING_ROOMS', true)
    commit('SET_ROOMS_FAILED', false)
    const startDate = rootState.route.query.start ? dayjs(rootState.route.query.start).format('YYYY-MM-DD') : null
    const endDate = rootState.route.query.end ? dayjs(rootState.route.query.end).format('YYYY-MM-DD') : null
    let params = {
      hotelId: hotelId,
      during_date: startDate && endDate ? `${startDate},${endDate}` : null,
      adult: rootState.route.query.adult
    }
    if (state.externalHotelSource.includes(state.hotel.hotelSource)) {
      params = {
        ...params,
        adult: rootState.yokoso.people.adult,
        child: rootState.yokoso.people.child,
        children_age: rootState.yokoso.people.childAge,
      }
    }
    return HOTELS.getHotelRooms(params, state.roomCancelToken).then(res => {
      commit('SET_ROOMS', res.data)
      return res
    }).catch(err => {
      commit('SET_ROOMS', [])
      console.error('fetchHotelRooms', err)
    }).finally(() => {
      commit('SET_LOADING_ROOMS', false)
    })
  },
  fetchHotelNearby: function ({ commit, state }, params) {
    commit('SET_HOTEL_NEARBY', [])
    commit('SET_ISLOADINGHOTELNEARBY', true)
    return HOTELS.fetchHotelNearby(params)
      .then(res => {
        commit('SET_HOTEL_NEARBY', res.data.searchData)
        return res
      })
      .catch(err => {
        commit('SET_HOTEL_NEARBY', [])
        console.error('fetchHotelNearby', err)
      })
      .finally(() => commit('SET_ISLOADINGHOTELNEARBY', false))
  }
}

// mutations
const mutations = {
  SET_ALLOWANCES: function (state, payload) {
    state.allowances = payload
  },
  SET_LOADING_HOTELS_MAP: function (state, payload) {
    state.isLoadingHotelsMap = payload
    state.hotelsMapCancelToken = axios.CancelToken.source()
  },
  SET_HOTELS_MAP: function (state, payload) {
    state.hotelsMap = payload
  },
  SET_LOADING_HOTEL: function (state, payload) {
    state.isLoadingHotel = payload
  },
  SET_LOADING_HOTELS: function (state, payload) {
    state.isLoadingHotels = payload
    state.hotelsCancelToken = axios.CancelToken.source()
  },
  SET_LOADING_FAVORITE: function (state, payload) {
    state.isLoadingFavorite = payload
  },
  SET_HOTELS_LIST: function (state, payload) {
    state.hotels = payload
  },
  SET_HOTEL: function (state, payload = {}) {
    // console.log('SET_HOTEL', payload)
    state.hotel = payload
  },
  SET_HOTEL_ADDONS: function (state, payload) {
    state.hotelAddons = payload
  },
  RESET_HOTEL_ADDONS: function (state, payload) {
    state.hotel.extraAddons = payload
  },
  SET_HOTELS_DETAIL: function (state, payload = {}) {
    const hotelIndex = _.findIndex(state.hotelsDetail, ['hotelUUID', payload.hotelUUID])
    if (hotelIndex > -1) {
      state.hotelsDetail[hotelIndex] = payload
    } else {
      state.hotelsDetail.push(payload)
    }
  },
  SET_HOTEL_ID: function (state, payload) {
    state.hotelId = payload
  },
  SET_IS_QUARANTINE: function (state, payload) {
    state.isQuarantineHotel = payload
  },
  SET_QUARANTINE_DATEPICKER_STYLE: function (state, { period = 0, startDate = '' }) {
    const highlightDateArray = []

    if (period && startDate) {
      for (let i = 1; i <= period; i++) {
        highlightDateArray.push(dayjs(startDate).add(i, 'day').toDate())
      }
      state.quarantineDatepickerStyle = [{
        highlight: { fillMode: 'outline', contentClass: 'text-blue-light' },
        dates: highlightDateArray
      }]
    } else {
      state.quarantineDatepickerStyle = []
    }
  },
  SET_LOADING_ROOMS: function (state, payload) {
    state.roomCancelToken = axios.CancelToken.source()
    state.isLoadingRooms = payload
  },
  SET_ROOMS_FAILED: function (state, payload) {
    state.setRoomsFailed = payload
  },
  SET_ROOMS: function (state, payload) {
    state.rooms = payload
    const hotelDetail = _.find(state.hotelsDetail, item => {
      return item.hotelUUID === state.hotelId
    })
    // GTM
    let list = []
    _.each(state.rooms, function (room, key) {
      _.each(room.plans, function (plan, planKey) {
        const id = `hotel/${state.hotelId}/room/${room.id}/plan/${plan.id}`
        const name = `[${hotelDetail.hotelName}] ${room.name} - ${plan.id}`
        list.push({
          'id': id,
          'sku': id,
          'name': name,
          'category': hotelDetail.hotelName,
          'list': hotelDetail.hotelName,
          'position': key > 0 ? key + planKey + 1 : key + planKey,
          'brand': room.name,
          'variant': plan.id,
          'price': plan.avgPrice
        })
      })
    })
    window.dataLayer.push({
      event: 'addImpression',
      'ecommerce': {
        'impressions': list
      }
    })

    // GTM GA4
    if (list.length > 0) {
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'TWD',
          value: 0,
          items: [{
            item_category: 'hotels',
            item_category2: hotelDetail.countryTextEn,
            item_brand: 'owljourney',
            price: 0,
            item_name: hotelDetail.hotelName,
            item_id: state.hotelId
          }]
        }
      })
    }
  },
  SET_TARGET_HOTEL: function (state, payload) {
    if (state.hotels?.data?.searchData) {
      let target = state.hotels.data.searchData.findIndex(hotel => hotel.data.hotelUUID === payload.hotelUUID)
      if (target > -1) {
        state.hotels.data.searchData.splice(target, 1, {
          ...state.hotels.data.searchData[target],
          data: {
            ...state.hotels.data.searchData[target].data,
            isFavorite: payload.isFavorite
          }
        })
      }
    }
  },
  SET_THIS_HOTEL_FAVORITE: function (state, payload) {
    const { hotelUUID, status } = payload
    state.hotel.isFavorite = status
    const hotelIndex = _.findIndex(state.hotelsDetail, hotel => hotel.hotelUUID === hotelUUID)
    if (hotelIndex > -1) {
      state.hotelsDetail[hotelIndex].isFavorite = status
    }
  },
  SET_INVENTORY: function (state, payload) {
    // console.log('SET_INVENTORY')
    const keys = Object.keys(payload)
    state.inventory = keys.filter(e => {
      if (payload[e] === false) {
        return dayjs(e).toDate()
      }
    })
  },
  SET_INVENTORY_PRICE: function (state, payload) {
    const keys = Object.keys(payload)
    state.inventoryPrice = keys.reduce((acc, curr) => {
      const obj = {}
      obj[curr] = payload[curr]
      acc.push(obj)
      return acc
    }, [])
  },
  RESET_INVENTORY: function (state, payload) {
    // console.log('RESET_INVENTORY')
    state.inventory = null
  },
  SET_ISLOADINGINVENTORY: function (state, payload) {
    state.isLoadingInventory = payload
  },
  SET_HOTEL_NEARBY: function (state, payload) {
    state.hotelNearby = payload
  },
  SET_ISLOADINGHOTELNEARBY: function (state, payload) {
    state.isLoadingHotelNearby = payload
  },
  SET_SCROLLING: function (state, payload) {
    state.scrolling = payload
  },
  SET_PAGEYOFFSET: function (state, payload) {
    state.pageYOffset = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
